import React from 'react';
import { IwocaLogo } from '@iwoca/orion';
import clsx from 'clsx';
import Link from 'next/link';
import { handleLogoTracking } from 'components/Navigation/Tracking/NavigationTracking';
import { useLocale } from 'hooks/useLocale';
import { PATH_NAMES } from 'utils/routes/pathNames';
import styles from './Logo.module.css';

type TProps = {
  iconOnly?: boolean;
};

export const Logo = ({ iconOnly = false }: TProps) => {
  const { locale } = useLocale();

  return (
    <Link
      href={PATH_NAMES.home()}
      passHref
      onClick={() => handleLogoTracking(locale)}
      className={styles.logoLink}
      data-testid="iwoca-logo"
    >
      <IwocaLogo
        iconOnly={iconOnly}
        className={clsx(styles.logo, { [styles['iconOnly']]: iconOnly })}
      />
    </Link>
  );
};
